import { useContext } from "react";
import AuthenticatedContractDetails from "../../../pages/contract/authenticatedContractDetails";
import { PublicContractDetails } from "../../../pages/contract/publicContractDetails";
import { isLoggedIn } from "../authContext";
import { ContractContext } from "../../../providers/contract";
import { EContractType } from "../../api/services/contract/models";
import MilestoneContractDetails from "../../../pages/contract/milestoneContractDetails";
import MilestoneDetails from "../../../pages/contract/milestoneDetails";

const ContractRoute = () => {
  const { contractType, contract } = useContext(ContractContext);

  if (!contract) {
    return <div></div>;
  }

  if (contractType === EContractType.COMPLEX_CONTRACT) {
    return <MilestoneContractDetails />;
  }

  if (contractType === EContractType.MILESTONE_CONTRACT && isLoggedIn()) {
    return <MilestoneDetails />;
  }

  return isLoggedIn() ? (
    <AuthenticatedContractDetails />
  ) : (
    <PublicContractDetails />
  );
};

export default ContractRoute;
